import { render, staticRenderFns } from "./dinoOpen.vue?vue&type=template&id=ead28254&"
import script from "./dinoOpen.vue?vue&type=script&lang=js&"
export * from "./dinoOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports